// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.plan.EncounterUpdateCarePlanItemEducationRequest */
/* istanbul ignore next */
@GandalfModel
export class EncounterUpdateCarePlanItemEducationRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Id is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	carePlanItemEducationId!: number;

	@GandalfValidator({ notNull: { message: 'Include in PHR is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	includeInPhr!: boolean;

}
